import { Handle, Position, type Node, type NodeProps } from '@xyflow/react';
import { Sparkles, SlidersHorizontal } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useWorkflowNodeContext } from '../WorkflowNodeContext';
import type { WorkflowNodeData } from '../types';

type AINodeProps = NodeProps<Node<WorkflowNodeData, 'ai'>>;

export function AINode({ id, data, selected }: AINodeProps) {
  const ctx = useWorkflowNodeContext();

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        className="!w-2.5 !h-2.5 !border-2 !bg-background !border-violet-500"
      />
      <div
        className={cn(
          'min-w-[200px] rounded-lg border-2 bg-card px-3 py-2.5 shadow-sm transition-shadow',
          'border-violet-500/60 bg-violet-500/5 shadow-violet-500/10',
          selected && 'ring-2 ring-violet-500 ring-offset-2 shadow-md'
        )}
      >
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-violet-500/20 text-violet-600 dark:text-violet-400">
            <Sparkles className="h-4 w-4" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium text-foreground">AI Step</p>
            <p className="truncate text-xs text-muted-foreground">{data.label}</p>
          </div>
          {ctx && (
            <button
              type="button"
              className="nodrag nopan flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground"
              onClick={() => ctx.openProperties(id)}
              aria-label="Open step properties"
            >
              <SlidersHorizontal className="h-3.5 w-3.5" />
            </button>
          )}
        </div>
        {data.description && (
          <p className="mt-1.5 line-clamp-2 text-xs text-muted-foreground">{data.description}</p>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-2.5 !h-2.5 !border-2 !bg-background !border-violet-500"
      />
    </>
  );
}
